/**
 * Whether a redeem is private is decided entirely by the broadcaster (the
 * menu item's own `isPrivate` flag) - product decided tippers should never be
 * able to opt a redeem into being private themselves, so there's no tipper-
 * facing toggle for it at all, on the website or via Discord.
 */

/**
 * Deny and undeny are redeemed by CreateReinDeny rather than the shared custom
 * tip flow, because they also move the deny status and advance the deny war -
 * so they always announce in the offline tips channel and can't be redeemed
 * privately. Keep in sync with the switch in
 * TipperResolvers.purchaseCustomTip.
 */
export const TYPES_WITHOUT_PRIVATE_REDEEM = ["deny", "undeny"];

export const supportsPrivateRedeem = (type?: string | null) =>
  !!type && !TYPES_WITHOUT_PRIVATE_REDEEM.includes(type);
